import getDefaultLanguage from './Language/getDefaultLanguage';

const getOrdinal = (index: number) => {
    const locale = getDefaultLanguage();
    const suffixes = ['th', 'st', 'nd', 'rd'];

    if (locale === 'en') {
        const v = index % 100;
        return index + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    }

    if (locale === 'hu') {
        return `${index}.`;
    }

    return undefined;
};

export default getOrdinal;
